import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";

import {
    AmountDropDownComponent,
    AmountDropDownComponentProps
} from "./components/amountDropDown.component";
import {
    AmountInputComponent,
    AmountInputComponentProps
} from "./components/amountInput.component";

type AmountProps = {
    components?: {
        Input: React.FC<AmountInputComponentProps>;
        DropDown: React.FC<AmountDropDownComponentProps>;
    };
} & AmountDropDownComponentProps &
    AmountInputComponentProps;

const Amount = ({
    components,
    roundingValue,
    activeDelivery,
    isUpdatingCart,
    minimumOrderQuantity,
    onQuantityChange,
    value,
    hasProductMultipleCartEntries,
    isFree,
    isFreeEntryAddedByCustomer
}: AmountProps) => {
    if (
        roundingValue === 1 ||
        activeDelivery === DeliveryType.ClickAndCollect
    ) {
        return components?.Input ? (
            <components.Input
                activeDelivery={activeDelivery}
                isUpdatingCart={isUpdatingCart}
                minimumOrderQuantity={minimumOrderQuantity}
                onQuantityChange={onQuantityChange}
                roundingValue={roundingValue}
                value={value}
                hasProductMultipleCartEntries={hasProductMultipleCartEntries}
                isFree={isFree}
                isFreeEntryAddedByCustomer={isFreeEntryAddedByCustomer}
            />
        ) : (
            <AmountInputComponent
                activeDelivery={activeDelivery}
                isUpdatingCart={isUpdatingCart}
                minimumOrderQuantity={minimumOrderQuantity}
                onQuantityChange={onQuantityChange}
                roundingValue={roundingValue}
                value={value}
                hasProductMultipleCartEntries={hasProductMultipleCartEntries}
                isFree={isFree}
                isFreeEntryAddedByCustomer={isFreeEntryAddedByCustomer}
            />
        );
    } else {
        return components?.DropDown ? (
            <components.DropDown
                isUpdatingCart={isUpdatingCart}
                minimumOrderQuantity={minimumOrderQuantity}
                onQuantityChange={onQuantityChange}
                roundingValue={roundingValue}
                value={value}
            />
        ) : (
            <AmountDropDownComponent
                isUpdatingCart={isUpdatingCart}
                minimumOrderQuantity={minimumOrderQuantity}
                onQuantityChange={onQuantityChange}
                roundingValue={roundingValue}
                value={value}
            />
        );
    }
};

export { Amount };
